/** Demo dismissals for ?mock=1 (ADR 0056): one question a person dismissed 40 minutes ago. */
import type { AsksState } from '@orgus/protocol';
import { MOCK_ASKS } from '../../lib/mock.ts';

const MIN = 60_000;

export function mockAsks(now: number): AsksState {
  return {
    setAside: [
      {
        askId: MOCK_ASKS.dismissedAsk,
        sessionId: MOCK_ASKS.dismissedSession,
        kind: 'dismiss',
        until: null,
        by: 'owner',
        from: 'Chrome on Windows',
        at: now - 40 * MIN,
        question: 'Do you also want me to refresh the lockfile?',
      },
    ],
  };
}
